import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import OTableHeadIn from "components/reusable/OTableHead";
import helpers from "utils/helpers";
import { AiFillEye } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
const IncomingTable = ({ filteredData, sort, setSort, page }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="overflow-x-auto relative rounded-lg border">
      <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
        <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400 dark:border-[#ffffff38]">
          <tr>
            <th scope="col" className="py-3 px-3 text-center">
              {t("S.NO")}
            </th>
            <OTableHeadIn sort={sort} name={"Customer"} setSort={setSort} />
            <OTableHeadIn
              sort={sort}
              name={t("MOBILE_NUMBER")}
              setSort={setSort}
            />
            <OTableHeadIn sort={sort} name={"Service Type"} setSort={setSort} />
            <OTableHeadIn sort={sort} name={"Booking Type"} setSort={setSort} />
            
            <OTableHeadIn
              sort={sort}
              name={"Booking Date & Time"}
              setSort={setSort}
            />
            <OTableHeadIn
              sort={sort}
              tableClass='text-right'
              name={t("Booking ID")}
              setSort={setSort}
            />
          
            <OTableHeadIn
              sort={sort}
              name={"O_CREATED_AT"}
              fieldName={"createdAt"}
              setSort={setSort}
            />

            <OTableHeadIn sort={sort} name={"ACTION"} />
          </tr>
        </thead>
        <tbody>
          <AnimatePresence>
            {filteredData?.map((item, idx) => (
              <motion.tr
                key={item?._id}
                initial={{ opacity: 0, y: 5 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.05 }}
                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
              >
                <td className="py-3 px-4 text-center border-r font-medium text-gray-900  dark:text-white">
                  {" "}
                  {idx + 1 + 10 * (page - 1)}
                </td>
                <td className="py-3 px-4 border-r">
                  {helpers.capitalizeFirstWord(
                    item.userDetails?.fullName || "N/A"
                  )}
                </td>
                <td className="py-3 px-4 border-r">
                  {" "}
                  +{item?.userDetails?.countryCode}-{item?.userDetails?.mobile}
                </td>
                <td className="py-3 px-4 border-r">
                  {helpers.capitalizeFirstWord(
                    item?.serviceDetails?.name || "N/A"
                  )}
                </td>
                <td className="py-3 px-4 border-r">
                  {helpers.capitalizeFirstWord(item?.bookingType || "N/A")}
                </td>
               
                <td className="py-3 px-4 border-r ">
                  {item?.bookingType === "immediate"
                    ? helpers.capitalizeFirstWord(item?.bookingType || "N/A")
                    : helpers.getFormattedDate(item?.dateTime, "MM/DD/YYYY hh:mm A")}
                </td>
                <td className="py-3 px-4 border-r text-right">
                  #{item?.bookingId || "N/A"}
                </td>
               
               
                <td className="py-2 px-3 whitespace-nowrap gap-2 border-r">
                  {helpers.getDateAndTime(item?.createdAt)}
                </td>

                <td
                  onClick={() => {
                     navigate(`/track-services/view/${item?._id}`);
                  }}
                  className="px-2 py-2 border-l text-center hover:bg-white hover:text-LightBlue dark:hover:bg-transparent "
                  title={"View"}
                >
                  <span className="flex justify-center items-center h-full">
                    <AiFillEye
                      className="text-slate-600 cursor-pointer"
                      size={23}
                    />
                  </span>
                </td>
              </motion.tr>
            ))}
          </AnimatePresence>

          {isEmpty(filteredData) ? (
            <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
              <td className="py-4 px-6" colSpan={12}>
                {t("O_NO_RECORD_FOUND")}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
};

export default IncomingTable;
